// src/components/LotusServices.jsx
import React from "react";

const servicesData = [
  {
    title: "Pune Cab Booking",
    image: "/images/service/1.jpg",
    description:
      "Book a cab instantly anywhere in Pune. Lotus Cab provides reliable, fast, and affordable city rides with professional drivers."
  },
  {
    title: "Online Cab Booking",
    image: "/images/service/5.jpg",
    description:
      "Skip the waiting! Use our website to book your cab within seconds and enjoy a smooth, hassle-free ride experience."
  },
  {
    title: "24/7 Cab Availability",
    image: "/images/service/4.jpg",
    description:
      "No matter the hour, Lotus Cab is always on the road. Early morning flights or late-night returns — we are available anytime."
  },
  {
    title: "One Way Cab Service",
    image: "/images/service/3.jpg",
    description:
      "Travel to another city without paying for return distance. Save money with our affordable one-way cab service."
  },
  {
    title: "Airport Cab Service",
    image: "/images/service/2.jpg",
    description:
      "On-time airport pickups and drop-offs. Our drivers track flight schedules to ensure zero waiting time."
  },
  {
    title: "Corporate Cab Service",
    image: "/images/service/6.jpg",
    description:
      "Dedicated cab solutions for businesses and professionals with priority booking and seamless travel experience."
  }
];

const LotusServices = () => {
  return (

<>


 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title">Services</h2>
        </div>
      </div>
    </section>

    <section className="services-section py-5">
      <div className="container">
        <div className="text-center mb-5">
          <h2 className="fw-bold">Lotus Cab – Serving Pune And Beyond</h2>
        </div>

        <div className="row g-4">
          {servicesData.map((service, index) => (
            <div key={index} className="col-md-6 col-lg-4">
              <div className="card h-100 border-success shadow-sm">
                <img
                  src={service.image}
                  className="card-img-top"
                  alt={service.title}
                />
                <div className="card-body">
                  <h5 className="card-title text-success fw-bold">
                    {service.title}
                  </h5>
                  <p className="card-text">{service.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>

</>
  );
};

export default LotusServices;
